export enum FdoAccessRulesKeyEnum {
  // --- Модуль FDO ---
  // --- Раздел FDO.SECTIONS.FDO ---

  // Вкладки
  FDO_FDO_KKT_READ = 'FDO_FDO_KKT_READ',
  FDO_FDO_KKT_WRITE = 'FDO_FDO_KKT_WRITE',

  FDO_FDO_RECEIPT_READ = 'FDO_FDO_RECEIPT_READ',
  FDO_FDO_RECEIPT_WRITE = 'FDO_FDO_RECEIPT_WRITE',

  FDO_FDO_KKT_ACTIVITY_READ = 'FDO_FDO_KKT_ACTIVITY_READ',

  FDO_FDO_ACTIVITY_READ = 'FDO_FDO_ACTIVITY_READ',
  FDO_FDO_ACTIVITY_WRITE = 'FDO_FDO_ACTIVITY_WRITE',
}
